import React, { Component } from 'react'
import { ReactSVG } from 'react-svg'
import { BnLabel1, BnLabel2 } from '../Label'
import { BnPage, BnSubpage } from '../Page'
import { BnForm, BnFormFields, BnFormFieldSeparator as Sep } from '../Form'
import { BnButton, BnBackButton } from '../Button'
import { BnInputField, BnInputFieldSeparator } from '../TextInput'
import { isIOS, consoleLog, isDesktop, isSafari, isChrome } from '../../classes/Platform.js'
import Google from '../../assets/Icons/Platforms/Google.svg'
import { Home, HomeButton, HomeInput } from '../Home'
import { ApiHighlights } from '../Home/ApiHighlights.js'
import { InputField } from '../InputField'
import AttunewiseLogo from '../../assets/Icons/AT3DLogo.png'
import SignIn from '../../assets/Icons/Signin.svg'
import Alert from '../../assets/Icons/Alert.svg'
//import Phone from '../../assets/Icons/Phone.svg'
import phone from 'phone';
import './index.css'
import AssistantIcon from '../../assets/Icons/AssistantICON.png'
const delay = seconds => new Promise(resolve => setTimeout(resolve, seconds*1000))
const Phone = null



export const Oof = props => {
  let message = props.error ? props.error.message: ''
  let style
  style = message ? null : { display: 'none' }
  return <div className='keyboardOof' style={style}>
           <HomeButton icon={Alert}
                       sublabel={props.sublabel}
                       buttonLabel={message} action={props.action}/>
           </div>
}

const KeyboardLogo = props => {
  return <div className='keyboardLogo'>
           <div className='keyboardLogoImg'>
             <img src={props.icon}/>
           </div>
           {props.text}
           </div>
}

const KeyboardStep = props => {
  return <div className='keyboardSettingsStep'>
           <div className='keyboardSettingsStepNumber'>
             {props.stepNumber}
           </div>
           <div className='keyboardSettingsStepIcon'>
             { props.icon && <ReactSVG src={props.icon}/>}
           </div>
           <div className='keyboardSettingsStepText'>
             {props.text}
           </div>
         </div>
}

const steps = [
  ]

class KeyboardSettings extends BnSubpage {

  takeMeThere = () => {
    this.props.me.openKeyboardSettings()    
  }
  renderContent() {
    const done = this.props.done
    let title = this.props.done ? "Keyboard is Enabled" : "Enable Intelligent Keyboard"
    const filteredSteps = steps.filter(x => {
      return this.props.isInstalled ? x.type !== 'installation' : true
    })
    return <div className='keyboardSettingsContent'>
             {done && <div className='keyboardInstallationDoneSpacer1'/>}
             <div className='keyboardSettingsTitle'>
               <BnLabel1 text={title}/>
             </div>
             {!done ? <div className='keyboardSettingStepsContainer'>
                         <div className='keyboardSettingSteps'>
                           {
                            filteredSteps.map((step, i) => {
                               let text = step.text
                               if (i == 0) {
                                 text = <div className='keyboardSettingStep2'>
                                          {text} <div className='keyboardSettingStep2TakeMeThere' onClick={this.takeMeThere}>Take me there</div>
                                        </div>
                               }
                               return <KeyboardStep
                                        stepNumber={i + 1}
                                        icon={step.icon}
                                        text={text}/>
                               
                             })
                           }
                         </div>
                      </div>
              :
              <div className='keyboardInstallationDoneSpacer2'/>
             }
             <BnButton label={'Done'} action={this.props.doneClicked}/>
             </div>
  }
}


export class GetStarted extends Component {
  componentDidMount() {
    if (!this.props.me) {
      //debugger
    }
  }
  render() {
    let text = this.props.text
    let icon = this.props.icon 
    //text = "Attunewise.ai"
    //icon = AttunewiseLogo

    return <div className='keyboardGetStartedPage'>
             <div className={'keyboardGetStartedContent' + (this.props.className ? ' ' + this.props.className : '')}>
               <div className='keyboardGetStartedLogo' text={this.props.text}>
                 <KeyboardLogo me={this.props.me} text={text} icon={icon}/>
               </div>
               <div className='keyboardGetStartedMiddle'>
                 {this.props.children}
               </div>
               {this.props.action && <div className='keyboardGetStartedButton'>
                                       <BnButton label={this.props.label || 'Get Started'} action={this.props.action}/>
                                     </div>}
             </div>
           </div>
  }
}


class KeyboardCreateAccount extends BnSubpage {

  componentDidUpdate() {
    if (this.props.form.onVerificationCodeInput) {
      if (!this.state.subpage) {
        this.next()
      }
    } else {
    }
  }

  next = () => {
    const back = () => {
      const form = this.getForm()
      form.onVerificationCodeInput = null
      this.back()
    }
    this.setState({
      subpage: () => <KeyboardVerificationCode me={this.props.me} form={this.getForm()} formErr={this.getFormErr()} onChange={this.onChange} next={this.props.next} back={back}/>
    })
  }

  renderDetail() {
    return <ApiHighlights me={this.props.me}/>
  }

  renderContent() {
    let text = 'Sign-in or Create Account'
    if (this.props.back) {
      //text = "Phone Number Verification"
    }
    const form = this.getForm()
    let formErr = this.getFormErr()
    const googleSignIn = async () => {
      await this.props.me.signInWithGoogle(true)
      if (!this.props.me.isSignedInAnonymously()) {
        this.props.back()
      }
    }
    return <GetStarted className='signInCreateAccount' me={this.props.me} text={text} icon={SignIn} label={'Next'} action={this.props.next}>
      {isDesktop() && <div className='googleSignInButtons'>
        <HomeButton label={'Google Account'} buttonLabel='Sign-in with Google' action={googleSignIn} icon={Google}/>
      </div>}
      <BnLabel2 text='Phone Number'/>
      <div className='bnSignInFields'>
        <BnInputField key='phone'  name='phoneNumber' label={''} formErr={formErr} form={form} type='tel' onChange={this.onChange} autoComplete={'tel'} busy={form.busy}/>
      </div>
        <div className='bnReferralCodeContainer'>
          {false &&<div className='bnReferralCode'>
        <BnLabel2 text='referral code'/>
        <div className='bnSignInFields'><BnInputField key='code' name='referralCode' label={''} formErr={this.getFormErr()} form={form} onChange={this.onChange} type={'number'}/> </div>
                   </div>}
        </div>
      <Oof error={formErr}/>
      </GetStarted>
  }  
}

class KeyboardVerificationCode extends BnSubpage {

  renderContent() {
    const form = this.getForm()
    const formErr = this.getFormErr()
    return <GetStarted back={this.props.back} className='signInVerificationCode' me={this.props.me} text="Enter your Verification Code" icon={Phone} label={'Next'} action={this.props.next}>
             <BnLabel2 text='Verification Code (check your messages)'/>
             <div className='bnSignInFields'><BnInputField key='code' name='verificationCode' label={''} formErr={this.getFormErr()} form={form} type='number' autocomplete={'one-time-code'} onChange={this.onChange}  busy={form.busy}/> </div>
             <Oof error={formErr}/>
           </GetStarted>
  }
}


export class KeyboardLogin extends BnSubpage {


  clearRecaptchaVerifier = () => {
    const verifier = this.verifier
    this.verifier = null
    this.verifierRenderPromise = null
    if (verifier) {
      try {
        verifier.clear()
      } catch (err) {
        console.error('Could not clear the phone reCAPTCHA verifier', err)
      }
    }
  }

  ensureRecaptchaVerifier = async () => {
    if (this.verifier) {
      await this.verifierRenderPromise
      return this.verifier
    }
    if (!this.recaptchaFun) {
      throw new Error('The phone verification control is not ready. Try again.')
    }

    const verifier = new this.props.me.firebase.auth.RecaptchaVerifier(this.recaptchaFun, {
      size: 'invisible'
    })
    this.verifier = verifier
    this.verifierRenderPromise = verifier.render()
    try {
      await this.verifierRenderPromise
      return verifier
    } catch (err) {
      if (this.verifier === verifier) {
        this.clearRecaptchaVerifier()
        if (this.recaptchaFun) this.recaptchaFun.replaceChildren()
      }
      throw err
    }
  }


  componentDidMount() {
    this.set('countryCode', 1)
    //this.set('referralCode', this.props.me.getInviteCode())
    if (this.props.onCreate) this.props.onCreate(this)
    this.sub = this.props.me.observeSelf().subscribe(self => {
      this.setState({
        self
      })
    })
  }
  
  componentWillUnmount() {
    this.clearRecaptchaVerifier()
    if (this.sub) {
      this.sub.unsubscribe()
    }
  }

  signIn = async () => {
    const form = this.getForm()
    let err
    if (!form.email) {
      err = {field: 'email', message: 'Email address is required'}
      this.setState({formErr: err})
      return
    }
    if (!form.password) {
      err = {field: 'password', message: 'Password is required'}
      this.setState({formErr: err})
      return
    }
    try {
      await this.props.me.signIn(form.email, form.password)
      this.setState({
        needsSignIn: false
      })
    } catch (err) {
      consoleLog(err)
      const message = err.message;
      let formErr
      if (err.code == "auth/user-not-found") {
        formErr = {field: 'email', message: "No user with that email."};
      } else if (err.code == "auth/too-many-requests") {
        formErr = {field: 'email', message: "Too many attempts. Try again later."};
      } else if (err.code == "auth/wrong-password") {
        formErr = {field: 'password', message: "Password incorrect."};
      } else if (err.code == "auth/network-request-failed") {
        formErr = {message: "You are not connected to the Internet."};
      } else if (err.code == "auth/invalid-verification-code") {
        formErr = {message: "Invalid verification code."};
      } else if (err.code) {
        formErr = {field: '', message: err.message};
      } else {
        return Promise.reject(err);
      }
      this.setState({
        formErr
      })
    }
  }

  signUp = async () => {
    const form = this.getForm()
    this.state.formErr = {}
    if (!form.phoneNumber) {
      this.setState({
        formErr: {
          field: 'phoneNumber',
          message: 'Phone number is required.'
        }
      })
      return
    }
    let phoneNumber = form.phoneNumber
    const converted = phone(phoneNumber);
    if (!converted.length) {
      this.state.formErr = {field: 'phoneNumber', message: 'Invalid phone number.'};
      this.forceUpdate()
      return
    } else {
      phoneNumber = converted[0];
    }
    const handleError = err => {
      form.busy = false
      let message = err.message
      let formErr
      if (err.code === 'auth/quota-exceeded') {
        message = 'Too many sign-in attempts from this number. Try again later.'
      } else if (err.code == "auth/too-many-requests") {
        message = 'Too many attempts. Try again later.'
      } else if (err.code == 'auth/internal-error') {
        message =  'Internal Error. Try again later.'
      } else if (err.code == "auth/network-request-failed") {
        message =  'You are not connected to the Internet.'
      } else if (err.code == "auth/invalid-verification-code") {
        formErr = {message: "Invalid verification code."};
      }  else {
        //debugger
      }
      if (!formErr) {
        formErr = { field: 'phoneNumber', message: message }
      }
      this.setState({
        formErr 
      })
    }
    if (!form.phoneNumberChecked) {
      form.phoneNumberChecked = true
      form.busy = true
      this.forceUpdate()
      try {
        const { exists } = await this.props.me.phoneNumberExists(phoneNumber)
        form.busy = false
        form.isSignUp = !exists
        this.forceUpdate()
      } catch (err) {
        console.error(err)
        handleError(err)
        return
      }
    }
    if (form.phoneNumberChecked && form.referralCode && !form.isSignUp) {
      this.state.formErr = {field: 'referralCode', message: 'Referral only available for new accounts'};
      this.forceUpdate()
      return
    }
    if (!form.verified) {
      if (!form.onVerificationCodeInput) {
        let result
        form.busy = true
        this.forceUpdate()
        try {
          const recaptcha = this.props.me.usesDesktopPhoneAuthBridge()
            ? null
            : await this.ensureRecaptchaVerifier()
          result = await this.props.me.signInWithPhoneNumber(phoneNumber, recaptcha)
        } catch (err) {
          console.error(err)
          form.busy = false
          handleError(err)
          return
        }
        form.busy = false
        form.onVerificationCodeInput = async code => {
          try {
            form.busy = true
            this.forceUpdate()
            const result1 = await result.confirm(code)
            form.busy = false
            form.user = result1.user
            form.onPasswordInput = null;
            form.onVerificationCodeInput = null;
            form.verified = true
            this.setState({
              subpage: null
            })
            this.clearRecaptchaVerifier()
            if (this.props.next) this.props.next()
            this.forceUpdate()
          } catch (err) {
            console.error('confirm exception', err)
            handleError(err)
            return
          }
        }
        this.forceUpdate()
      } else {
        if (!form.verificationCode) {
          this.state.formErr = {field: 'verificationCode', message: "Verification code is required."};
          this.forceUpdate()
          return
        }
        form.busy = true
        await form.onVerificationCodeInput(form.verificationCode)
        this.forceUpdate()
      }
    } else {
      this.props.next()
    }
  }

  render() {
    return <div className='keyboardLogin'>
             <div key='recaptcha-fun' className='recaptchaFun' ref={
                    ref=>{
                      this.recaptchaFun=ref
                    }
                  }/>
             {this.renderContent()}
           </div>
  }

  renderDetail() {
    return <ApiHighlights me={this.props.me}/>
  }

  renderContent() {
    return <KeyboardCreateAccount title={this.props.title} me={this.props.me} onChange={this.onChange} form={this.getForm()} formErr={this.state.formErr} next={this.signUp} back={this.props.next}/>
  }
}
